import { CustomButton } from "@/components/ui-elements/CustomButton";
import { Box, Typography, Link } from "@mui/material";
import { styled } from "@mui/system";
import type * as React from "react";

const IPRestrictionWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#F0F0F0",
}));

const IPRestrictionTitle = styled(Typography)(() => ({
  color: "black",
  fontSize: "24px",
  fontWeight: "bold",
  marginTop: "254px",
}));

const IPRestrictionDescription = styled(Typography)(() => ({
  color: "black",
  fontSize: "16px",
  fontWeight: 500,
  marginTop: "70px",
  marginBottom: "70px",
  textAlign: "left",
  maxWidth: "600px",
  lineHeight: "2",
}));

const IPRestrictionEmail = styled(Link)(() => ({
  color: "#255ACC",
  fontSize: "16px",
  fontWeight: 500,
  textDecoration: "none",
}));

const IPRestriction: React.FC = () => {
  return (
    <IPRestrictionWrapper>
      <IPRestrictionTitle variant="h1">
        アクセスが制限されています
      </IPRestrictionTitle>
      <IPRestrictionDescription variant="body1">
        お客様のIPアドレスからのアクセスは許可されていません。
        <br />
        このシステムは特定のIPアドレス範囲からのみアクセスが許可されています。
        <br />
        アクセス権限が必要な場合は、以下の方法でご対応ください：
        <br />
        • 許可されたネットワーク環境からアクセスする
        <br />
        • システム管理者に連絡し、現在のIPアドレスの追加を依頼する
        <br />
        <br />
        ご不明な点は、下記連絡先へお問い合わせください
        <br />
        お問い合わせ先：{" "}
        <IPRestrictionEmail href="mailto:cs@recerqa.com">
          cs@recerqa.com
        </IPRestrictionEmail>
      </IPRestrictionDescription>
      <CustomButton
        label="画面を更新する"
        onClick={() => {
          window.location.reload();
        }}
        size="md"
        sx={{ fontSize: "14px" }}
      />
    </IPRestrictionWrapper>
  );
};

export default IPRestriction;
